import React, { useState } from "react"
import { motion } from 'framer-motion'
import { StoreRoutes } from "../../Common/Routes"
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { FaPowerOff } from "react-icons/fa"
import { setLoggedIn, setUserDetails } from "../../Store/Auth/actions"

const StoreSideBar = ({ }) => {

    const history = useHistory()
    const userDetails = useSelector((state) => state.auth.userDetails)
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    const dispatch = useDispatch()

    const logout = () => {
        localStorage.removeItem('token')
        localStorage.removeItem('accountType')
        localStorage.removeItem('buyNowProducts')
        localStorage.removeItem('userDetails')
        dispatch(setUserDetails({}))
        dispatch(setLoggedIn(false))
        history.push('/')
        window.location.reload()
    }
    console.log(userDetails)
    return (
        <>
            <motion.div className="relative hidden md:block min-w-48 w-auto bg-primeColor/20 rounded-lg h-[80vh] px-2 flex flex-col py-2">
                {
                    StoreRoutes.map((storeRoute) => {
                        return storeRoute.sideBar && <motion.div key={storeRoute.title} className="flex flex-row my-2 text-black items-center">
                            <storeRoute.icon />
                            <motion.div key={storeRoute?.link} className={`flex ${history?.location.pathname === storeRoute?.link && 'text-nameColor'} flex-row py-2 px-2 cursor-pointer hover:text-nameColor`} onClick={() => { history.push((storeRoute?.link).replace(":storeId", userDetails.subject.sellerId._id || userDetails.subject.sellerId)) }}>
                                {storeRoute.title}
                            </motion.div>
                        </motion.div>
                    })
                }
                <motion.div className="flex flex-row my-2 text-black items-center cursor-pointer">
                    <FaPowerOff className={`my-1 mx-2  transition duration-300 hover:text-nameColor text-[grey]`} /> <motion.div className={`mx-2`} onClick={() => logout()}>Logout</motion.div>
                </motion.div>
            </motion.div>
            <motion.div className="relative block md:hidden w-full text-end rounded-lg px-5 flex flex-col py-2">
                <motion.div
                    className="text-black px-2 cursor-pointer lg:hidden"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    {isMenuOpen ? (
                        <span className="text-3xl">&#x2715; {/* Close Icon */}</span>
                    ) : (
                        <span className="text-3xl">&#9776; {/* Hamburger Icon */}</span>
                    )}
                </motion.div>
                {
                    isMenuOpen && StoreRoutes.map((storeRoute) => {
                        return storeRoute.sideBar && <motion.div key={storeRoute.title} className="flex flex-row my-2 text-black items-center">
                            <storeRoute.icon />
                            <motion.div key={storeRoute?.link} className={`flex ${history?.location.pathname === storeRoute?.link && 'text-nameColor'} flex-row py-2 px-2 cursor-pointer hover:text-nameColor`} onClick={() => { setIsMenuOpen(false); history.push((storeRoute?.link).replace(":storeId", userDetails.subject.accountType === 'seller' ? userDetails.subject.sellerId : userDetails.subject.sellerId._id)) }}>
                                {storeRoute.title}
                            </motion.div>
                        </motion.div>
                    })
                }
            </motion.div>
        </>
    )
}

export default StoreSideBar